module.exports = __webpack_public_path__ + "static/media/four.d090d724.webp";